export default "__VITE_ASSET__CHQs7LLT__"